module.exports = __webpack_public_path__ + "img/coffee_mobile_320px.a8c099b9.jpg";